/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-unresolved */
const obj = require('js/app/core/obj');

module.exports = obj;
